// extracted by mini-css-extract-plugin
export default {"wrapper":"tabField_wrapper__OFEH-"};